import { combineReducers } from "redux"

import productData from "./productData"
import publishedAds from "./publishedAds"
import totalData from "./totalData"
import ui from "./ui"

export default combineReducers({
  productData,
  publishedAds,
  totalData,
  ui
})
